import { FC, ReactNode } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import RoutingUtils from '../utils/utils-routing';
import { RefineSearchButtons } from './RefineSearchButtons';
import { SearchScope } from '../../store/search/state';

type Props = Pick<RouteComponentProps, 'location'> & {
    readonly searchScope?: SearchScope;
    readonly currentRefine?: string;
    readonly refinedSearchCategories?: { [key: string]: string };
    readonly didYouMean?: string;
    readonly onUnsetRefineSearch: () => void;
    readonly onRefineSearch: (refine: string) => void;
};

function buildDidYouMean(props: Props) {
    let didYouMeanInner: ReactNode = null;

    if (props.didYouMean) {
        const searchScopeKey = props.searchScope?.key ?? null;
        //TODO: searchScopeKey shouldn't be null here. Some Bug causes it to be null. Once fixed remove this check
        if (!searchScopeKey) {
            return null;
        }

        const didYouMeanLocation = RoutingUtils.searchLocationDescriptor(
            props.didYouMean,
            searchScopeKey,
            props.location.pathname
        );

        didYouMeanInner = (
            <div className="did-you-mean">
                <h4>Did you mean...</h4>
                <Link className="dym-label" key="did-you-mean" to={didYouMeanLocation}>
                    {props.didYouMean}
                    <i className="material-icons dym-ic">arrow_forward</i>
                </Link>
            </div>
        );
    }
    return didYouMeanInner;
}

const SearchResultHeader: FC<Props> = props => {
    const didYouMeanInner = buildDidYouMean(props);

    return (
        <div className="search-results-header">
            {didYouMeanInner}
            <RefineSearchButtons
                refinedSearchCategories={props.refinedSearchCategories}
                onRefineSearch={props.onRefineSearch}
                onUnsetRefineSearch={props.onUnsetRefineSearch}
                currentRefine={props.currentRefine}
            />
        </div>
    );
};

export default SearchResultHeader;
